/*
sai krishna 01/19/2023 2698197526 added profile of batchtable for open
Ashraf 01/25/2023 2698125110 added profile of batchtable for open
Ashraf 01/25/2023 2698197526 Added popup for approve and reject actions
sai krishna 01/27/2023 2698197526 changed disable condition
Ashraf 01/30/2023 2698197526 fixed clickable action issue
sai krishna 01/31/2023 2698197526 changed table label order
sai krishna 01/31/2023 2698197526 integrated failed record api.
Ravi 03/10/2023 2698197526 disabled Approve a Batch based on successful.
Sohel 03/29/2023 2698197526 Disabled Approve Batch Button
Prakash 26/04/2023 2698197526 fixed icon issue
Sohel 04/26/2023 2698197526 Added Delete Batch Functionality
Akhila 06/08/2023 2698197526 created date change to date created field and column
*/
import React, {useEffect, useState, useRef} from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import ClearIcon from '@material-ui/icons/Clear';
import {useSelector, useDispatch} from 'react-redux';
import GuiTable from '../../../../components/FormComponents/GuiTable';
import {tablePageRows, defaultRows} from '../../../../constants/ReusableTablePagination';
import {TablePagination} from '@material-ui/core';
import {useHistory} from 'react-router';
import moment from 'moment';
import CheckIcon from '@material-ui/icons/Check';
import {httpPaginationPost} from '.././../../../util/Rest';
import {
  postApproveBatch,
  postDeleteBatch,
  postRejectBatch,
  resetMessage,
  postUndoBatch,
  postApprovedUrl
} from '../../../../redux/reducers/accountBatch';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../components/CustomSnackBar';
import DeleteTableRecordPopup from '../../../../util/DeleteTableRecordPopup';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import GuiAutoComplete from '../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../components/FormComponents/GuiTextField';
import SettingsBackupRestoreOutlinedIcon from '@material-ui/icons/SettingsBackupRestoreOutlined';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';

import {Form, Formik} from 'formik';
import { Grid} from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
  root: {
    'width': '100%',
    // backgroundColor: "#fff",
    'borderRadius': '4px',
    'border': '1px solid #f3f3f3',
    '& .MuiAccordionDetails-root': {
      display: 'block',
      whiteSpace: 'nowrap',
      padding: '10px',
      backgroundColor: '#fff',
    },
    '& .MuiAccordionSummary-root': {
      backgroundColor: '#f3f3f3',
    },
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 600,
    flexBasis: '50%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
  detailsText: {
    backgroundColor: '#FFF',
    padding: 10,
    boxShadow:
      '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
  },
  accountSpan: {
    'backgroundColor': '#38FA8A',
    'padding': '3px 10px',
    'borderRadius': 50,
    '& .MuiTypography-body1': {
      fontSize: '12px !important',
      fontWeight: 600,
      marginTop: '3px',
      color: '#FFF',
    },
  },
  detailsCard: {
    padding: 10,
    borderRadius: '0px 0px 8px 8px',
    backgroundColor: '#fbfbfb',
  },

  cardStyles: {
    whiteSpace: 'nowrap',
    padding: '0 15px',
  },
  labelName: {
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
  },
  inputLabel: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      fontWeight: '600',
    },
  },
  selectGender: {
    fontSize: '13px',
  },
  selectLabel: {
    fontWeight: '600 !important',
  },
  datePicker: {
    '& .MuiIconButton-root': {
      'padding': '0px !important',
      ' & .MuiSvgIcon-root': {
        fontSize: '1.3rem',
      },
    },
    '& .MuiOutlinedInput-input': {
      fontSize: '13px',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '6px',
    },
  },
  textField: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '40px !important',
    },
  },
  
  link: {
    color: '#320469',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '14px',
    fontFamily: 'articulat-cf sans-serif ',
  },
}));

const Assigned = ({value, newBusinessAccess}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [statusOption, setStatusOption] = useState({key: ['Open','Approved','Rejected'], value: 'All'});


  const {isLoading, successMsg, errorMsg, actionStatus} = useSelector(
    ({accountBatch}) => accountBatch,
  );

  const tableRef = useRef('');

  const [title, setTitle] = useState('');
  const [Description, setDescription] = useState('');
  const [isAction, setIsAction] = useState('');
  const [actionData, setActionData] = useState({});


  useEffect(() => {
    if (errorMsg || successMsg) {
      tableRef?.current?.onQueryChange();
      setTimeout(() => {
        dispatch(resetMessage());
        setDisabled(false);
      }, 2500);
    }
    setStatusOption('');
  }, [errorMsg, successMsg]);

  const columns = [
    {
      title: 'Batch Name',
      field: 'batchName',
      render: (rowData) =>
        rowData?.batchStatus === 'COMPLETED' ? (
          <div
            className={classes.link}
            onClick={() => {
              history.push({
                pathname: `/batch-account-list`,
                state: {
                  BatchName: rowData.batchName,
                  BatchId:rowData.dmbatchId,
                },
              });
            }}
          >
            {rowData.batchName}
          </div>
        ) : (
          <div>{rowData?.batchName}</div>
        ),
    },
    {
      title: 'Batch Status',
      field: 'batchStatus',
    },
    {
      title: 'Status',
      field: 'dmStatus',
      render: (rowData) => {
        return rowData?.dmStatus === 'Rejected' ? (
          <div className="completed-status status">
            <span style={{color: '#ff8b00', fontWeight: 'bold'}}>Rejected</span>
          </div>
        ) : rowData?.dmStatus === 'Approved' ? (
          <div className="completed-status status" style={{fontWeight: 'bold', color: '#00af00'}}>
            <span>Approved</span>
          </div>
        ) : (
          <div className="status" style={{color: 'black', fontWeight: 'bold'}}>
            <span>Open</span>
          </div>
        );
      }
    },    
    {
      title: 'Code',
      field: 'dmCode',
    },
    {
      title: 'Type',
      field: 'dmType',
    },
    {
      title: 'Total',
      field: 'fileCount',
    },
    {
      title: 'Successful ',
      field: 'insertCount',
    },
    {
      title: 'Failed',
      field: 'failedCount',
      render: (rowData) =>
        rowData?.batchStatus === 'IN_PROGRESS' || rowData?.failedCount === 0 ? (
          <div>{rowData?.failedCount}</div>
        ) : (
          <div
            className={classes.link}
            onClick={() => {
              history.push({
                pathname: `/batch-account-list`,
                state: {
                  BatchName: rowData.batchName,
                  failedCount: true,
                },
              });
            }}
          >
            {rowData.failedCount}
          </div>
        ),
    },
    {
      title: 'Deleted',
      field: 'deleteCount',
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) =>
        rowData.createdDate ? moment(rowData.createdDate).format('MM/DD/YYYY') : '',
    },
  ];

  const StatusOptions = [
    {key: ['Open','Approved','Rejected'], value: 'All'},
    {key: ['Open'], value: 'Open'},
    {key: ['Rejected'], value: 'Rejected'},
    {key: ['Approved'], value: 'Approved'},
  ];

  const initialValues = {
    statusCode: ''
  };

  const handleClose = () => {
    setIsAction(false);
    setActionData({});
  };

  useEffect(() => {
    if (actionStatus === 200) {
      handleClose();
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
    }
  }, [actionStatus]);

  const handleSubmit = () => {
    if (title === 'Approve Batch') {
      setDisabled(true);
      dispatch(postApproveBatch(actionData?.dmbatchId));
    } else if (title === 'Reject Batch') {
      dispatch(postRejectBatch(actionData?.dmbatchId));
    } else if (title === 'Delete Batch') {
      dispatch(postDeleteBatch(actionData?.dmbatchId));
    }else if (title === 'Undo Batch') {
      dispatch(postUndoBatch(actionData?.dmbatchId));
    }
  };

  return (
    <div>
      <h2 className="search-title">New Business Search</h2>
      <Formik
        onSubmit={(values) => handleSubmit(values)}
        initialValues={initialValues}
        enableReinitialize
      >
        {(props) => {
          const { values, handleChange, setFieldValue} =
            props;
          return (
            <div className={classes.ruleGroupCard}>
              <Form autoComplete="off" noValidate>
                <div>
                  <Grid
                    className=" new-standard-textfields align-items-center"
                    container
                    spacing={2}
                  >
                    <Grid
                      item
                      xs={12}
                      md={12}
                      lg={12}
                      xl={12}
                      className="form-group account-guarantor"
                    >
                      <GuiAutoComplete
                        classes={{
                          popper: classes.popper,
                          option: classes.option,
                        }}
                        name="statusCode"
                        id="statusCode"
                        size="small"
                        options={StatusOptions}
                        required
                        value={values.statusCode}
                        getOptionLabel={(option) => {
                          return option && option?.value;
                        }}
                        onChange={(e, value) => {
                          let filterValue = value
                          if(value != null){
                            filterValue = value;
                          }else {
                            filterValue = {key: ['Open','Approved','Rejected']};
                          }
                          handleChange(e);
                          setFieldValue('statusCode', filterValue);
                          setStatusOption(filterValue);
                          tableRef?.current?.onQueryChange();
                        }}
                        renderInput={(params) => (
                          <div className="select-field">
                            <GuiTextField
                              {...params}
                              className={` ${classes.labelName}`}
                              variant="outlined"
                              margin="dense"
                              // InputLabelProps={{ shrink: true }}
                              label="Status"
                              placeholder="Select Status"
                            />
                          </div>
                        )}
                      />
                    </Grid>
                  </Grid>
                </div>
              </Form>
            </div>
          );
        }}
      </Formik>
      <DeleteTableRecordPopup
        open={isAction}
        dialogClose={handleClose}
        title={title}
        value={Description}
        handleSubmit={handleSubmit}
        disabled={disabled}
      />
      <div className={classes.root}>
        <div className="global-field-table mui-custom-table-container new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            isLoading={isLoading}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `dmbatch/search/all`;
                const passValues = {
                  batchName: '',
                  batchStatus: '',
                  createdDate: '',
                  dmStatusList: statusOption.key,
                  dmType: '',
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  limit: query.pageSize ? query.pageSize : null,
                  page:
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                httpPaginationPost(url, passValues)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObjects;
                      setArrayLast(data.length === 1);
                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      // setArrayLast(response.data.response.resultObjects.length === 1);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            localization={{
              body: {editRow: {deleteText: 'Are you sure you want to delete this record?'}},
            }}
            options={{
              search: false,
              toolbar: false,
              pageSizeOptions: tablePageRows,
              pageSize: rows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              (rowData) => ({
                icon: CheckIcon,
                tooltip: 'Approve a Batch',
                disabled:
                  rowData?.batchStatus === 'IN_PROGRESS' ||
                  rowData?.insertCount === 0 ||
                  (!newBusinessAccess?.edit && !newBusinessAccess?.add),
                onClick: (event, rowData) => {
                  setActionData(rowData);
                  setTitle('Approve Batch');
                  setDescription(
                      `Are you sure you want to approve this ${rowData?.batchName} batch ?`,
                  );
                  setIsAction(true);
                },
              }),
              (rowData) => ({
                icon: ClearIcon,
                tooltip: 'Reject a Batch',
                disabled:
                  rowData?.batchStatus === 'IN_PROGRESS' ||
                  (!newBusinessAccess?.edit && !newBusinessAccess?.add),
                onClick: (event, rowData) => {
                  setActionData(rowData);
                  setTitle('Reject Batch');
                  setDescription(
                      `Are you sure you want to reject this ${rowData?.batchName} batch ?`,
                  );
                  setIsAction(true);
                },
              }),
              (rowData) => ({
                icon: DeleteOutlineOutlinedIcon,
                tooltip: 'Delete a Batch',
                disabled: rowData.fileCount !== 0 || !newBusinessAccess?.delete,
                onClick: (event, rowData) => {
                  setActionData(rowData);
                  setTitle('Delete Batch');
                  setDescription(
                      `Are you sure you want to delete this ${rowData?.batchName} batch ?`,
                  );
                  setIsAction(true);
                },
              }),
              (rowData) => {
                if (rowData?.dmStatus?.toLowerCase() === 'rejected') {
                  return {
                    icon: () => (
                      <SettingsBackupRestoreOutlinedIcon />
                    ),                      
                    tooltip: 'Undo',
                    onClick: (event, rowData) => {
                      setActionData(rowData);
                      setTitle('Undo Batch');
                      setDescription(
                        `Are you sure you want to undo this ${rowData?.batchName} batch?`,
                      );
                      setIsAction(true);
                    },
                  };
                }
                return null;
              },    
              (rowData) => {
                return {
                  icon: () => <GetAppOutlinedIcon />,
                  tooltip: !rowData?.acknowledgementDocKey ? '' : 'Download',
                  disabled: !rowData?.acknowledgementDocKey,
                  onClick: (event, rowData) => {
                    dispatch(
                      postApprovedUrl({
                        dockey: rowData?.acknowledgementDocKey,
                      }),
                    );
                  },
                };
              },          
            ]}
            
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </div>
      {/* {isLoading && <PageLoader />} */}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </div>
  );
};

export default Assigned;
